import React from "react"
import styled from "styled-components"

import tokens from "../_tokens"
import Link from "./link"

const StyledFooter = styled.div`
  background-color: ${tokens.color.black};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2em;
`

function Footer(props) {
  return (
    <StyledFooter {...props}>
      <Link to="http://bridgetool.io/">Made with Bridge</Link>
    </StyledFooter>
  )
}

export default Footer
